import React from 'react'
import Image from 'next/image'
import { statsObj } from 'components/LSRevamp/CounsellorLandingPage/CounsellorRelatedStats/constant'
import { CounsellorObj } from 'components/LSRevamp/CounsellorLandingPage/CounsellorRelatedStats/CounsellorStatsInterface'

const CounsellorRelatedStats: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl md:text-[42px] font-sans font-bold px-[24px] xl:px-[324px] text-center mt-[30px] lg:mt-[75px] leading-[31.56px] md:leading-[55.23px]">
        Our Study Abroad Counsellors are your biggest cheerleaders
      </h2>
      <div className="flex flex-col md:flex-row items-center md:justify-evenly lg:mt-[37px] ">
        {statsObj.map((ele: CounsellorObj, index: number) => {
          return (
            <div
              className="lg:h-[235px] lg:w-[232px] text-center text-[#121212] "
              key={index}
            >
              <div className="flex justify-center mt-[30px] lg:mt-0 ">
                <Image src={ele.image} width={47.86} height={48} alt={'icon'} />
              </div>
              <h3
                className={`text-2xl font-bold  mt-[17px] px-[69px] lg:px-0 text-center leading-9 ${
                  index == 2 ? 'lg:px-[35px]' : ''
                }`}
              >
                {ele.title}
              </h3>
              <div className="text-lg mt-[17px]  px-[22px] lg:px-0 leading-[27px] ">
                {ele.description}
              </div>
            </div>
          )
        })}
      </div>
      <div className="text-xl md:text-[28px] font-sans font-bold px-[33px] lg:px-0 mt-[30px] lg:mt-[50px] text-center leading-[26.5px] md:leading-[43.5px]">
        <h4>
          <span className="text-primary">5000+</span> students admitted with{' '}
          <span className="text-primary">97%</span> success rate till now.
        </h4>
        <div>Take a leap towards your study abroad journey.</div>
      </div>
    </>
  )
}
export default CounsellorRelatedStats
